module.exports = __webpack_public_path__ + "static/media/p_50_4.3fe6174c.png";